import React, { Component } from 'react';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';
// import GD from '../RestAPI/getData';
import cjquery from 'jquery';
import language from '../../../../assets/languages/language';
import ModalComponent from '../../../Common/Modal';
import VideoValidateReportIcons from '../../../Common/VideoValidateReportIcons';
import FrmSubscriptionCheck from '../../../RestAPI/FrmSubscription';
import PartnerFRMSubscriptionCheck from '../../../RestAPI/PartnerSubscription/FrmSubscription';
import AlertMessage from '../../../config/alertMessage';
import './Frmvideodisplay.css';
import { getIpAddress } from '../../../../common/getIpAddress';
import { flowPlayerVideoDisplayUrl } from '../../../../common/constant';
import FlashCard from '../../../../components/FlashCard';

class Frmvideodisplay extends Component {
  constructor(props) {
    window.scrollTo(0, 0);
    super(props);
    this.state = {
      successAlert: false,
      alert_status: false,
      showFreePremiumFRM_1: true,
      showFreePremiumFRM_2: true,

      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: AlertMessage.messageContent_frm,
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class',
      // MessageTitle: `<i class="icon-info icons font-2xl d-block "></i>`,
      token: '',
      idname: '',
      ValidToken: false,
      reportLoading: false,
      all_questions: '',
      chapters: [],
      all_questions_state: [],
      video_display: '',
      video_display_qq: '',
      posterImage: '',
      url_id: '',
      currentUrl: '',
      video_title: '',
      video_display_no: '',
      allChapters: [],
      Chapter_Title: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      notesCSS: 'fa fa-book mark-action-btn',
      questionsCSS: 'fa fa-question-circle-o mark-action-btn',
      showFreePremium: this.props.params.showFreePremium === '0',
      currentReading: this.props.params.id,
      comment_update_id: '',
      currentChapterNo: '',
      currentReadingNo: '',
      currentReadingTitle: '',
      subscriptionstatus: '',
      selectedmenu: 'frm',
      subscription_details_for_isActive: '',
      pdfData: [],
      pdf_file: '',
      type: this.props.params.type === '0' ? 'intro' : 'notintro',
      userType: '',
      saveVideo_text: `${language.LC().SAVE_VIDEO}`,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      isFlashCardHidden: true,
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      videoPartLevel: '',
      showCapsules: '',
    };
    this.childRef = null;
    this.setChildRef = element => {
      this.childRef = element;
    };
  }

  static contextTypes = { router: React.PropTypes.object };

  goToPreviousReading() {
    if (
      this.state.currentUrl === 0 ||
      this.state.currentUrl < 0 ||
      this.state.currentUrl > this.state.chapters.length - 1
    ) {
      return;
    }
    this.setState({
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveVideo_text: `${language.LC().SAVE_VIDEO}`,
    });
    this.context.router.push({
      pathname: `/frm/videodisplay/${this.props.params.id}/${this.props.params.showFreePremium}/${
        this.props.params.type ? this.props.params.type : 1
      }/${
        this.props.params.chapter_id
          ? this.props.params.chapter_id
          : this.state.chapters[this.state.currentUrl].chapter_id
      }/${this.state.currentUrl}`,
      search: `?showCapsules=${this.state.showCapsules ? this.state.showCapsules : false}&level=${
        this.state.videoPartLevel
          ? this.state.videoPartLevel
          : this.state.chapters[this.state.currentUrl].level
      }`,
    });
    if (this.state.chapters[this.state.currentUrl - 1].free === 1) {
      this.setState({ currentUrl: this.state.currentUrl - 1 }, () => {
        this.setState({ video_display: this.state.chapters[this.state.currentUrl].url_id });
        this.setState({ video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq });
        this.setState({ posterImage: this.state.chapters[this.state.currentUrl].posterImage });
        this.setState({ video_title: this.state.chapters[this.state.currentUrl].title });
        this.setState({ currentReading: this.state.chapters[this.state.currentUrl].id });
        this.setState({ currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id });
        this.setState({ currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no });
        this.setState({ currentReadingTitle: this.state.chapters[this.state.currentUrl].title });
        this.setState({ pdf_file: this.state.chapters[this.state.currentUrl].pdf_file });
      });
      this.context.router.push({
        pathname: `/frm/videodisplay/${this.props.params.id}/${this.props.params.showFreePremium}/${
          this.props.params.type ? this.props.params.type : 1
        }/${
          this.props.params.chapter_id
            ? this.props.params.chapter_id
            : this.state.chapters[this.state.currentUrl].chapter_id
        }/${this.state.currentUrl}`,
        search: `?showCapsules=${this.state.showCapsules ? this.state.showCapsules : false}&level=${
          this.state.videoPartLevel
            ? this.state.videoPartLevel
            : this.state.chapters[this.state.currentUrl].level
        }`,
      });
      this.trackUserWatchedVideo(
        this.state.chapters[this.state.currentUrl].id,
        this.state.currentUrl,
      );
    } else {
      const data = { token: this.state.token, idname: this.state.idname };
      FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then(resp => {
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            const subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({ subscription_details });
            const data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
              async resp_exam => {
                if (resp_exam.success) {
                  const exam_data = resp_exam.examData;
                  // const selectedmen = this.state.selectedmenu;
                  let isInArray_var = false;
                  const examPlanData = resp_exam.examPlan[0];
                  isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                    this.state.videoPartLevel,
                    exam_data,
                    examPlanData,
                  );
                  if (isInArray_var) {
                    this.setState({ currentUrl: this.state.currentUrl - 1 }, () => {
                      this.setState({video_display: this.state.chapters[this.state.currentUrl].url_id,});
                      this.setState({video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,});
                      this.setState({posterImage: this.state.chapters[this.state.currentUrl].posterImage,});
                      this.setState({video_title: this.state.chapters[this.state.currentUrl].title,});
                      this.setState({currentReading: this.state.chapters[this.state.currentUrl].id,});
                      this.setState({currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,});
                      this.setState({currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,});
                      this.setState({currentReadingTitle: this.state.chapters[this.state.currentUrl].title,});
                      this.setState({pdf_file: this.state.chapters[this.state.currentUrl].pdf_file,});
                    });
                    this.context.router.push({
                      pathname: `/frm/videodisplay/${this.props.params.id}/${
                        this.props.params.showFreePremium
                      }/${this.props.params.type ? this.props.params.type : 1}/${
                        this.props.params.chapter_id
                          ? this.props.params.chapter_id
                          : this.state.chapters[this.state.currentUrl].chapter_id
                      }/${this.state.currentUrl}`,
                      search: `?showCapsules=${
                        this.state.showCapsules ? this.state.showCapsules : false
                      }&level=${
                        this.state.videoPartLevel
                          ? this.state.videoPartLevel
                          : this.state.chapters[this.state.currentUrl].level
                      }`,
                    });

                    this.trackUserWatchedVideo(
                      this.state.chapters[this.state.currentUrl].id,
                      this.state.currentUrl,
                    );
                    return;
                  } else {
                    return this.toggleAlert();
                  }
                } else {
                }
              },
            );
          }
        } else {
          if (resp.profileInfo.exam_selected === '') {
            return this.toggleAlert();
          } else {
            const subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({ subscription_details });

            const data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
              resp_exam => {
                if (resp_exam.success) {
                  const exam_data = resp_exam.examData;
                  // const selectedmen = this.state.selectedmenu;
                  let isInArray_var = false;
                  isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(
                    this.state.videoPartLevel,
                    exam_data,
                  );

                  if (isInArray_var) {
                    this.setState({ currentUrl: this.state.currentUrl - 1 }, () => {
                      this.setState({video_display: this.state.chapters[this.state.currentUrl].url_id,});
                      this.setState({video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,});
                      this.setState({posterImage: this.state.chapters[this.state.currentUrl].posterImage,});
                      this.setState({video_title: this.state.chapters[this.state.currentUrl].title,});
                      this.setState({currentReading: this.state.chapters[this.state.currentUrl].id,});
                      this.setState({currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,});
                      this.setState({currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,});
                      this.setState({currentReadingTitle: this.state.chapters[this.state.currentUrl].title,});
                      this.setState({pdf_file: this.state.chapters[this.state.currentUrl].pdf_file,});
                    });
                    this.context.router.push({
                      pathname: `/frm/videodisplay/${this.props.params.id}/${
                        this.props.params.showFreePremium
                      }/${this.props.params.type ? this.props.params.type : 1}/${
                        this.props.params.chapter_id
                          ? this.props.params.chapter_id
                          : this.state.chapters[this.state.currentUrl].chapter_id
                      }/${this.state.currentUrl}`,
                      search: `?showCapsules=${
                        this.state.showCapsules ? this.state.showCapsules : false
                      }&level=${
                        this.state.videoPartLevel
                          ? this.state.videoPartLevel
                          : this.state.chapters[this.state.currentUrl].level
                      }`,
                    });
                    this.trackUserWatchedVideo(
                      this.state.chapters[this.state.currentUrl].id,
                      this.state.currentUrl,
                    );
                    return;
                  } else {
                    return this.toggleAlert();
                  }
                } else {
                }
              },
            );
          }
        }
      });
    }
  }

  goToNextReading() {
    if (
      this.state.currentUrl === this.state.chapters.length - 1 ||
      this.state.currentUrl >= this.state.chapters.length - 1
    ) {
      // console.log('this.state.currentUrl === (this.state.chapters.length - 1)');
      return;
    }
    this.setState({
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveVideo_text: `${language.LC().SAVE_VIDEO}`,
    });
    if (this.state.chapters[this.state.currentUrl + 1].free === 1) {
      // console.log("goToNextReading if");

      this.setState({ currentUrl: this.state.currentUrl + 1 }, () => {
        this.setState({ video_display: this.state.chapters[this.state.currentUrl].url_id });
        this.setState({ video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq });
        this.setState({ posterImage: this.state.chapters[this.state.currentUrl].posterImage });
        this.setState({ video_title: this.state.chapters[this.state.currentUrl].title });
        this.setState({ currentReadingTitle: this.state.chapters[this.state.currentUrl].title });
        this.setState({ currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id });
        this.setState({ currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no });
        this.setState({ currentReading: this.state.chapters[this.state.currentUrl].id });
        this.setState({ pdf_file: this.state.chapters[this.state.currentUrl].pdf_file });
      });
      this.context.router.push({
        pathname: `/frm/videodisplay/${this.props.params.id}/${this.props.params.showFreePremium}/${
          this.props.params.type ? this.props.params.type : 1
        }/${
          this.props.params.chapter_id
            ? this.props.params.chapter_id
            : this.state.chapters[this.state.currentUrl].chapter_id
        }/${this.state.currentUrl}`,
        search: `?showCapsules=${this.state.showCapsules ? this.state.showCapsules : false}&level=${
          this.state.videoPartLevel
            ? this.state.videoPartLevel
            : this.state.chapters[this.state.currentUrl].level
        }`,
      });
      this.trackUserWatchedVideo(
        this.state.chapters[this.state.currentUrl].id,
        this.state.currentUrl,
      );
      return;
    } else {
      const data = { token: this.state.token, idname: this.state.idname };
      FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then(resp => {
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            const data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;

            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
              async resp_exam => {
                if (resp_exam.success) {
                  const exam_data = resp_exam.examData;
                  // const selectedmen = this.state.selectedmenu;
                  let isInArray_var = false;
                  const examPlanData = resp_exam.examPlan[0];
                  isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                    this.state.videoPartLevel,
                    exam_data,
                    examPlanData,
                  );
                  if (isInArray_var) {
                    this.setState({ currentUrl: this.state.currentUrl + 1 }, () => {
                      this.setState({video_display: this.state.chapters[this.state.currentUrl].url_id,});
                      this.setState({video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,});
                      this.setState({posterImage: this.state.chapters[this.state.currentUrl].posterImage,});
                      this.setState({video_title: this.state.chapters[this.state.currentUrl].title,});
                      this.setState({currentReading: this.state.chapters[this.state.currentUrl].id,});
                      this.setState({currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,});
                      this.setState({currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,});
                      this.setState({currentReadingTitle: this.state.chapters[this.state.currentUrl].title,});
                      this.setState({pdf_file: this.state.chapters[this.state.currentUrl].pdf_file,});
                    });
                    this.context.router.push({
                      pathname: `/frm/videodisplay/${this.props.params.id}/${
                        this.props.params.showFreePremium
                      }/${this.props.params.type ? this.props.params.type : 1}/${
                        this.props.params.chapter_id
                          ? this.props.params.chapter_id
                          : this.state.chapters[this.state.currentUrl].chapter_id
                      }/${this.state.currentUrl + 1}`,
                      search: `?showCapsules=${
                        this.state.showCapsules ? this.state.showCapsules : false
                      }&level=${
                        this.state.videoPartLevel
                          ? this.state.videoPartLevel
                          : this.state.chapters[this.state.currentUrl].level
                      }`,
                    });
                    this.trackUserWatchedVideo(
                      this.state.chapters[this.state.currentUrl].id,
                      this.state.currentUrl,
                    );
                    return;
                  } else {
                    return this.toggleAlert();
                  }
                } else {
                  //console.log('fail');
                }
              },
            );
          }
        } else {
          if (resp.profileInfo.exam_selected === '') {
            return this.toggleAlert();
          } else {
            const subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({ subscription_details });
            const data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
              resp_exam => {
                if (resp_exam.success) {
                  const exam_data = resp_exam.examData;
                  // const selectedmen = this.state.selectedmenu;
                  let isInArray_var = false;
                  isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(
                    this.state.videoPartLevel,
                    exam_data,
                  );
                  if (isInArray_var) {
                    this.setState({ currentUrl: this.state.currentUrl + 1 }, () => {
                      this.setState({video_display: this.state.chapters[this.state.currentUrl].url_id,});
                      this.setState({video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,});
                      this.setState({posterImage: this.state.chapters[this.state.currentUrl].posterImage,});
                      this.setState({video_title: this.state.chapters[this.state.currentUrl].title,});
                      this.setState({currentReading: this.state.chapters[this.state.currentUrl].id,});
                      this.setState({currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,});
                      this.setState({currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,});
                      this.setState({currentReadingTitle: this.state.chapters[this.state.currentUrl].title,});
                      this.setState({pdf_file: this.state.chapters[this.state.currentUrl].pdf_file,});
                    });
                    this.context.router.push({
                      pathname: `/frm/videodisplay/${this.props.params.id}/${
                        this.props.params.showFreePremium
                      }/${this.props.params.type ? this.props.params.type : 1}/${
                        this.props.params.chapter_id
                          ? this.props.params.chapter_id
                          : this.state.chapters[this.state.currentUrl].chapter_id
                      }/${this.state.currentUrl}`,
                      search: `?showCapsules=${
                        this.state.showCapsules ? this.state.showCapsules : false
                      }&level=${
                        this.state.videoPartLevel
                          ? this.state.videoPartLevel
                          : this.state.chapters[this.state.currentUrl].level
                      }`,
                    });
                    this.trackUserWatchedVideo(
                      this.state.chapters[this.state.currentUrl].id,
                      this.state.currentUrl,
                    );
                    return;
                  } else {
                    return this.toggleAlert();
                  }
                } else {
                }
              },
            );
          }
        }
      });
    }
  }

  // function to track user watched video
  trackUserWatchedVideo = (id, index) => {
    // const result = getDeviceDetails();
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      id,
      videoIndex: index,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/trackUserVideowatch`, data);
  };

  pdfOpen = () => {
    const { chapters, currentUrl } = this.state;
    if (this.state.userType === 'paid') {
      // const result = getDeviceDetails();
      const data = {
        token: this.state.token,
        idname: this.state.idname,
        id: chapters[currentUrl].id,
        videoIndex: currentUrl,
        city: this.state.user_city,
        country: this.state.user_country,
        state: this.state.user_state,
        continent: this.state.user_continent,
        ip: this.state.user_ip,
      };
      FD.callAPI(`${App_data.backend_api}/frm_question_bank/trackUserVideoPPTDownload`, data).then(
        resp => {
          if (resp.success) {
            const myWindow = window.open(this.state.pdf_file);
            myWindow.focus();
          }
          return resp;
        },
      );
    } else {
      this.toggleAlert();
    }
  };

  /*
  ----------------------------------
    Function to show Report box
  ---------------------------------
  */
  displayReportForm = () => {
    this.setState({ report_block: 'card show_block' });
  };

  _downloadPDF = () => {
    // console.log('Download PDF')
  };

  /*
  --------------------------------
    Function to hide Report box
  -------------------------------
  */
  hideReportForm = () => {
    document.getElementById('comment').value = '';
    this.setState({ report_block: 'card hide_block' });
  };

  /*
  ------------------------------------------
    Function to save new report question
  -----------------------------------------
  */
  reportQuestion = id => {
    const comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }

    // const result = getDeviceDetails();
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      video_id: id,
      videoIndex: this.state.currentUrl,
      comment,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
      level: this.state.videoPartLevel,
    };
    this.setState({ reportLoading: true });
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/videoReportQuestion`, data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  onClose = () => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };
  /*
  ---------------------------------
   Function to toggle Comment box
  ---------------------------------
  */
  _getToggleComment = () => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  /*
  ---------------------------------
   Function to toggle Flash box
  ---------------------------------
  */
  getToggleFlash = () => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  /*
  -----------------------------------------------------------------
   Function to Save flash Card And display new stored flash card
  -----------------------------------------------------------------
  */
  saveFlashCard = id => {
    if (document.getElementById('flash_card').value === '') {
      return;
    }
    const flash_card = document.getElementById('flash_card').value;
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      video_id: id,
      flash_card,
      level: this.state.videoPartLevel,
    };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/videoSaveFlashCards`, data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('flash_card').value = '';
        const params = {
          token: this.state.token,
          idname: this.state.idname,
          video_id: id,
        };
        FD.callAPI(`${App_data.backend_api}/frm_question_bank/videoGetFlashCards`, params).then(
          response => {
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block' });
                response.flash_cards.map(items => (
                  <li key={items.id}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this.editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a className='pointer_class' onClick={this.deleteFlash.bind(this, items)}>
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block' });
              }
              this.setState({ flash_data: <p>{language.LC().NO_FLASHCARD_FOUND}</p> });
            } else {
              const flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({
                ValidToken: false,
                flash_data: flash_cards,
                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
              });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  /*
  ----------------------------------
   Function to Edit Flash card
  ----------------------------------
  */
  editFlash = item => {
    this.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block' });
    document.getElementById('flash_card').value = item.flash_card;
  };

  /*
  ----------------------------------
   Function to delete flash card
  ----------------------------------
  */
  deleteFlash = item => {
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/videoDeleteFlashCards`, data).then(
      resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
          });
          document.getElementById('flash_card').value = '';
          const flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          this.setState({ flash_data: flash_cards });
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
  };

  getChapters = () => {
    this.context.router.push({
      pathname: '/frm/videoLessons',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  moveToNotes = () => {
    // const final_exam = [];
    const data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          const data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          const dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                // const selectedmen = this.state.selectedmenu;
                let isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                  this.state.videoPartLevel,
                  exam_data,
                  examPlanData,
                );
                if (isInArray_var) {
                  this.context.router.push({
                    pathname: `/frm/notesview/${this.state.currentReadingNo}/${
                      this.state.currentChapterNo
                    }/${this.state.currentReadingTitle}/${this.state.currentChapterNo}`,
                    state: {
                      token: this.state.token,
                      idname: this.state.idname,
                      reading: {
                        id: this.state.currentReadingNo,
                        chapter_no: this.state.currentChapterNo,
                        reading: this.state.currentReadingTitle,
                        chapter: this.state.currentChapterNo,
                        level: this.state.videoPartLevel,
                      },
                    },
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          return this.toggleAlert();
        } else {
          const data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          const dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                // const selectedmen = this.state.selectedmenu;
                let isInArray_var = false;

                isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(
                  this.state.videoPartLevel,
                  exam_data,
                );

                if (isInArray_var) {
                  this.context.router.push({
                    pathname: `/frm/notesview/${this.state.currentReadingNo}/${
                      this.state.currentChapterNo
                    }/${this.state.currentReadingTitle}/${this.state.currentChapterNo}`,
                    state: {
                      token: this.state.token,
                      idname: this.state.idname,
                      reading: {
                        id: this.state.currentReadingNo,
                        chapter_no: this.state.currentChapterNo,
                        reading: this.state.currentReadingTitle,
                        chapter: this.state.currentChapterNo,
                        level: this.state.videoPartLevel,
                      },
                    },
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                //console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  /*
  --------------------------------------------------
  Function to redirect page to viewquestions page
  --------------------------------------------------
  */
  moveToPracticeQuestions = () => {
    // const final_exam = [];
    const user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, user_data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          const data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          const dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                // const selectedmen = this.state.selectedmenu;
                let isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                  this.state.videoPartLevel,
                  exam_data,
                  examPlanData,
                );
                if (isInArray_var) {
                  this.runCode('paid');
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.runCode('free');
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          return this.toggleAlert();
        } else {
          const data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          const dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                // const selectedmen = this.state.selectedmenu;
                let isInArray_var = false;
                isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(
                  this.state.videoPartLevel,
                  exam_data,
                );
                if (isInArray_var) {
                  this.runCode('paid');
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.runCode('free');
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
              }
            },
          );
        }
      }
    });
  };

  runCode(subscriptionstatus) {
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: this.state.currentReadingNo,
      chapter_id: this.state.currentChapterNo,
      offset: 0,
      limit: 1,
      subscriptionstatus,
    };

    FD.callAPI(`${App_data.backend_api}/frm_question_bank/getQuestions`, data).then(resp => {
      if (resp.success) {
        if (resp.questions.length) {
          this.context.router.push({
            pathname: `/frm/questions/${this.state.currentReadingNo}/${
              this.state.currentChapterNo
            }/${this.state.currentReadingTitle}/${this.state.subscriptionstatus}/${
              this.props.params.chapter
            }/${this.state.videoPartLevel}`,
            state: {
              token: this.state.token,
              idname: this.state.idname,
              reading: {
                id: this.state.currentReadingNo,
                chapter_no: this.state.currentChapterNo,
                reading: this.state.currentReadingTitle,
              },
              subscriptionstatus: this.state.subscriptionstatus,
              level: this.state.videoPartLevel,
            },
          });
        } else {
          this.toggleAlert();
        }
      }
    });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.currentReading !== this.state.currentReading) {
      const params = {
        token: this.state.token,
        idname: this.state.idname,
        video_id: this.state.currentReading,
      };

      await this.getSavedVideo(this.state.currentReading);
      // var params = {
      //   token: this.state.token,
      //   idname: this.state.idname,
      //   video_id: this.state.currentReading,
      // };
      await FD.callAPI(`${App_data.backend_api}/frm_question_bank/videoGetFlashCards`, params).then(
        response => {
          let flash_cards = '';
          if (response.success) {
            this.setState({ ValidToken: true });
            if (response.flash_cards.length > 0) {
              this.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block' });
              flash_cards = response.flash_cards.map((items, index) => (
                <li key={index}>
                  <div className=''>
                    <ul className='icon_list'>
                      <li>
                        <a className='pointer_class' onClick={this.editFlash.bind(this, items)}>
                          <i className='fa fa-pencil' />
                        </a>
                      </li>
                      <li>
                        <a className='pointer_class' onClick={this.deleteFlash.bind(this, items)}>
                          <i className='fa fa-close' />
                        </a>
                      </li>
                    </ul>
                    <div className={this.state.flash_class}>
                      <h4 />
                      <p>{items.flash_card}</p>
                    </div>
                  </div>
                </li>
              ));
            } else {
              this.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block' });
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
            }
            this.setState({ flash_data: flash_cards });
          } else {
            flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
            this.setState({
              ValidToken: false,
              flash_data: flash_cards,
              flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
            });
          }
        },
      );
    }
  }

  async componentDidMount() {
    // console.log(
    //   '--------------this.props---------------------->',
    //   this.props.params.showFreePremium,
    // );

    const { location } = this.props;
    const { level, showCapsules, chapter_name } = location.query;
    this.setState({
      showCapsules,
      videoPartLevel: level,
      chapterName: chapter_name,
    });
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    if (this.state.showFreePremium) {
      this.setState({ userType: 'free' });
    } else if (!this.state.showFreePremium) {
      this.setState({ userType: 'paid' });
    }
    if (this.props.params.index) {
      this.setState({
        // eslint-disable-next-line radix
        currentUrl: this.props.params.index ? parseInt(this.props.params.index) : 0,
      });
    } else {
      this.setState({ currentUrl: 0 });
    }
    const datas = { token: this.state.token, idname: this.state.idname };
    await FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, datas).then(async resp => {
      if (resp.profileInfo.exam_selected === '') {
      } else {
        const data_arr = resp.profileInfo.exam_selected
          ? JSON.parse(resp.profileInfo.exam_selected)
          : null;
        const dataset = {
          token: this.state.token,
          idname: this.state.idname,
          examid: data_arr,
        };
        await FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
          resp_exam => {
            if (resp_exam.success) {
              const exam_data = resp_exam.examData;
              let isInArray_var = false;
              isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(1, exam_data);
              if (isInArray_var) {
                this.setState({ showFreePremiumFRM_1: false });
              } else {
                this.setState({ showFreePremiumFRM_1: true });
              }
              // var exam_data = resp_exam.examData;
              let isInArray_var1 = false;
              isInArray_var1 = FrmSubscriptionCheck.checkFrmVideosSubscription(2, exam_data);
              if (isInArray_var1) {
                this.setState({ showFreePremiumFRM_2: false });
              } else {
                this.setState({ showFreePremiumFRM_2: true });
              }
            } else {
            }
          },
        );
      }
    });
    const data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      chapter_id: this.props.params.chapter_id || this.props.params.id,
    };
    await FD.callAPI(
      `${App_data.backend_api}/frm_question_bank/getcfavideosChapterwise`,
      data,
    ).then(async resp => {
      if (resp.success) {
        // console.log(resp)
        await this.setState({ ValidToken: true });
        await this.setState({ chapters: resp.cfavchapter });
        await this.setState({ pdf_file: this.state.chapters[this.state.currentUrl].pdf_file });
        await this.setState({ currentReading: this.state.chapters[this.state.currentUrl].id });
        await this.setState({ video_display: this.state.chapters[this.state.currentUrl].url_id });
        await this.setState({video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,});
        await this.setState({posterImage: this.state.chapters[this.state.currentUrl].posterImage,});
        await this.setState({
          video_display_previous: this.state.chapters[this.state.currentUrl].url_id_qq
            ? this.state.chapters[this.state.currentUrl].url_id_qq
            : this.state.chapters[this.state.currentUrl].url_id,
        });
        await this.setState({ video_title: this.state.chapters[this.state.currentUrl].title });
        await this.setState({
          video_display_next: this.state.chapters[this.state.currentUrl + 1]
            ? this.state.chapters[this.state.currentUrl + 1].url_id_qq
              ? this.state.chapters[this.state.currentUrl + 1].url_id_qq
              : this.state.chapters[this.state.currentUrl + 1].url_id
            : null,
        });
        await this.setState({currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,});
        await this.setState({currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,});
        await this.setState({currentReadingTitle: this.state.chapters[this.state.currentUrl].title,});
      } else {
        this.setState({ ValidToken: false });
      }

      return resp;
    });

    await FD.callAPI(`${App_data.backend_api}/frm_question_bank/getfrmVideos`, data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true, allChapters: resp.cfavideo });
        if (this.props.params.chapter_id === undefined || this.props.params.chapter_id === null) {
          this.setState({Chapter_Title: resp.frmvideo[this.props.params.chapter_id - 1].chapter_name,});
        }
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    const params = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      video_id: this.state.currentReading,
    };

    await this.getSavedVideo(this.state.currentReading);
    // var params = {
    //   idname: storage_session['idname'],
    //   token: storage_session['token'],
    //   video_id: this.state.currentReading,
    // };
    await FD.callAPI(`${App_data.backend_api}/frm_question_bank/videoGetFlashCards`, params).then(
      response => {
        let flash_cards = '';
        if (response.success) {
          this.setState({ ValidToken: true });
          if (response.flash_cards.length > 0) {
            this.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block' });
            flash_cards = response.flash_cards.map((items, index) => (
              <li key={index}>
                <div className=''>
                  <ul className='icon_list'>
                    <li>
                      <a className='pointer_class' onClick={this.editFlash.bind(this, items)}>
                        <i className='fa fa-pencil' />
                      </a>
                    </li>
                    <li>
                      <a className='pointer_class' onClick={this.deleteFlash.bind(this, items)}>
                        <i className='fa fa-close' />
                      </a>
                    </li>
                  </ul>
                  <div className={this.state.flash_class}>
                    <h4 />
                    <p>{items.flash_card}</p>
                  </div>
                </div>
              </li>
            ));
          } else {
            this.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block' });
            flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          }
          this.setState({ flash_data: flash_cards });
        } else {
          flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          this.setState({
            ValidToken: false,
            flash_data: flash_cards,
            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
          });
        }
      },
    );

    // const params = {
    //   idname: storage_session['idname'],
    //   token: storage_session['token'],
    // };
    await FD.callAPI(`${App_data.backend_api}/frm_question_bank/getcfa_video_pdf`, data).then(
      resp => {
        if (resp.success) {
          this.setState({ pdfData: resp });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  getSavedVideo = async data => {
    const params = {
      token: this.state.token,
      question_id: data,
      idname: this.state.idname,
    };
    await FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFavVideo`, params).then(
      response => {
        if (response.success) {
          this.setState({
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            saveVideo_text: `${language.LC().Video_Saved}`,
            bookmarkColor: 'rgb(54, 141, 84)',
            isFlashCardHidden: false,
          });
        } else {
          this.setState({ isFlashCardHidden: true });
        }
      },
    );
  };

  toggleAlert = () => {
    this.setState({ alert_status: !this.state.alert_status });
  };

  goPremium = () => {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  getVideourl = async (index, url_id, title, id, url_id_qq, posterImage, free, item) => {
    // console.log('item----------------------------', item);
    if (free === 1) {
      this.setState(
        {
          video_display: url_id,
          video_display_qq: url_id_qq,
          posterImage,
          currentUrl: index,
          video_title: title,
          currentReading: item.id,
          currentChapterNo: item.chapter_id,
          currentReadingNo: item.reading_no,
          currentReadingTitle: item.title,
          pdf_file: item.pdf_file,
        },
        () => {
          this.context.router.push({
            pathname: `/frm/videodisplay/${this.props.params.id}/${
              this.props.params.showFreePremium
            }/${this.props.params.type ? this.props.params.type : 1}/${
              this.props.params.chapter_id ? this.props.params.chapter_id : item.chapter_id
            }/${this.state.currentUrl}`,
            search: `?showCapsules=${
              this.state.showCapsules ? this.state.showCapsules : false
            }&level=${this.state.videoPartLevel ? this.state.videoPartLevel : item.level}`,
          });
        },
      );
      await this.trackUserWatchedVideo(id, index);
      await this.savelastVideo(id, index, item.level);
    } else {
      const data = { token: this.state.token, idname: this.state.idname };
      FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then(resp => {
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            const data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;

            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
              async resp_exam => {
                if (resp_exam.success) {
                  const exam_data = resp_exam.examData;
                  // const selectedmen = this.state.selectedmenu;
                  let isInArray_var = false;
                  const examPlanData = resp_exam.examPlan[0];
                  if (item.chapter_id === 11) {
                    isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                      1,
                      exam_data,
                      examPlanData,
                    );
                    if (!isInArray_var) {
                      isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                        2,
                        exam_data,
                        examPlanData,
                      );
                    }
                  } else {
                    isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                      this.state.videoPartLevel,
                      exam_data,
                      examPlanData,
                    );
                  }
                  // isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                  //   this.state.videoPartLevel,
                  //   exam_data
                  // );
                  if (isInArray_var) {
                    this.setState(
                      {
                        video_display: url_id,
                        video_display_qq: url_id_qq,
                        posterImage,
                        currentUrl: index,
                        video_title: title,
                        currentReading: item.id,
                        currentChapterNo: item.chapter_id,
                        currentReadingNo: item.reading_no,
                        currentReadingTitle: item.title,
                        pdf_file: item.pdf_file,
                      },
                      () => {
                        this.context.router.push({
                          pathname: `/frm/videodisplay/${this.props.params.id}/${
                            this.props.params.showFreePremium
                          }/${this.props.params.type ? this.props.params.type : 1}/${
                            this.props.params.chapter_id
                              ? this.props.params.chapter_id
                              : item.chapter_id
                          }/${this.state.currentUrl}`,
                          search: `?showCapsules=${
                            this.state.showCapsules ? this.state.showCapsules : false
                          }&level=${
                            this.state.videoPartLevel ? this.state.videoPartLevel : item.level
                          }`,
                        });
                      },
                    );

                    await this.trackUserWatchedVideo(id, index);
                    await this.savelastVideo(id, index, item.level);
                    return;
                  } else {
                    return this.toggleAlert();
                  }
                }
              },
            );
          }
        } else {
          if (resp.profileInfo.exam_selected === '') {
            return this.toggleAlert();
          } else {
            const subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({ subscription_details });

            const data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
              async resp_exam => {
                if (resp_exam.success) {
                  const exam_data = resp_exam.examData;
                  // const selectedmen = this.state.selectedmenu;
                  let isInArray_var = false;
                  if (item.chapter_id === 11) {
                    isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(1, exam_data);
                    if (isInArray_var) {
                      this.setState({ showFreePremiumFRM_1: false });
                    } else {
                      this.setState({ showFreePremiumFRM_1: true });
                    }
                    if (!isInArray_var) {
                      isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(2, exam_data);

                      if (isInArray_var) {
                        this.setState({ showFreePremiumFRM_2: false });
                      } else {
                        this.setState({ showFreePremiumFRM_2: true });
                      }
                    }
                  } else {
                    isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(
                      this.state.videoPartLevel,
                      exam_data,
                    );
                  }
                  // isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(
                  //   this.state.videoPartLevel,
                  //   exam_data
                  // );
                  if (isInArray_var) {
                    this.setState(
                      {
                        video_display: url_id,
                        video_display_qq: url_id_qq,
                        posterImage,
                        currentUrl: index,
                        video_title: title,
                        currentReading: item.id,
                        currentChapterNo: item.chapter_id,
                        currentReadingNo: item.reading_no,
                        currentReadingTitle: item.title,
                        pdf_file: item.pdf_file,
                      },
                      () => {
                        this.context.router.push({
                          pathname: `/frm/videodisplay/${this.props.params.id}/${
                            this.props.params.showFreePremium
                          }/${this.props.params.type}/${this.props.params.chapter_id}/${
                            this.state.currentUrl
                          }`,
                          search: `?showCapsules=${
                            this.state.showCapsules ? this.state.showCapsules : false
                          }&level=${
                            this.state.videoPartLevel ? this.state.videoPartLevel : item.level
                          }`,
                        });
                      },
                    );

                    await this.trackUserWatchedVideo(id, index);
                    await this.savelastVideo(id, index, item.level);
                    return;
                  } else {
                    return this.toggleAlert();
                  }
                } else {
                }
              },
            );
          }
        }
      });
    }
  };

  /*
  -----------------------
    saved viewed video
  -----------------------
  */

  savelastVideo = async (id, index, level) => {
    const { token, idname } = this.state;
    const data_data = {
      token,
      idname,
      video_id: id,
      videoIndex: index,
      level,
    };
    await FD.callAPI(
      `${App_data.backend_api}/frm_question_bank/saveLastViewedVideo`,
      data_data,
    ).then(response => {
      if (response.success) {
        this.setState({ ValidToken: true });
      }
    });
  };

  /*
  --------------------------------------------------------------------
   Function to Display Saved Question on button and save in database
  --------------------------------------------------------------------
  */
  saveFavVideo = item => {
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      video_id: item,
      level: this.state.videoPartLevel,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      // return;

      FD.callAPI(`${App_data.backend_api}/frm_question_bank/unsaveFavVideoByUserID`, data).then(
        resp => {
          if (resp.success) {
            if (this.childRef) {
              this.childRef.deleteFlash();
            }
            this.setState({
              ValidToken: true,
              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
              bookmarkColor: '',
              saveVideo_text: `${language.LC().SAVE_VIDEO}`,
              isFlashCardHidden: true,
            });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );
    } else {
      FD.callAPI(`${App_data.backend_api}/frm_question_bank/saveFavVideoByUserID`, data).then(
        resp => {
          if (resp.success) {
            this.setState({
              ValidToken: true,
              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              bookmarkColor: 'rgb(54, 141, 84)',
              saveVideo_text: `${language.LC().Video_Saved}`,
              isFlashCardHidden: false,
            });
            this.getToggleFlash();
          } else {
            this.setState({ ValidToken: false, isFlashCardHidden: true });
          }
          return resp;
        },
      );
    }
  };

  render() {
    const {
      reportLoading,
      chapters,
      currentReading,
      videoPartLevel,
      isFlashCardHidden,
      pdf_file,
      bookmarkCSS,
      bookmarkColor,
      type,
      questionsCSS,
      saveVideo_text,
      showFreePremium,
    } = this.state;
    // const chapters = this.state.chapters;
    const styles_css = { marginBottom: '20px' };
    let data = '';
    if (this.state.chapters.length) {
      data = chapters.map((item, index) => (
        <div key={item.id}>
          <div className='full-width' key={item.id}>
            <div className='videotitle' key={item.id} value={item.id}>
              {item.chapter_id === 11 ? (
                this.state.showFreePremiumFRM_1 === true &&
                this.state.showFreePremiumFRM_2 === true ? (
                  item.free === 1 ? (
                    <div className='video-type-free'>{language.LC().FREE}</div>
                  ) : (
                    <div className='video-type-primum'>{language.LC().PREMIUM}</div>
                  )
                ) : (
                  <div />
                )
              ) : this.state.showFreePremium ? (
                item.free === 1 ? (
                  <div className='video-type-free'>{language.LC().FREE}</div>
                ) : (
                  <div className='video-type-primum'>{language.LC().PREMIUM}</div>
                )
              ) : (
                <div />
              )}
              <button
                type='button'
                name='videourl'
                id={item.id}
                className={
                  item.url_id_qq
                    ? item.url_id_qq === this.state.video_display_qq
                      ? 'active'
                      : ''
                    : item.url_id === this.state.video_display
                    ? 'active'
                    : ''
                }
                onClick={this.getVideourl.bind(
                  this,
                  index,
                  item.url_id,
                  item.title,
                  item.id,
                  item.url_id_qq,
                  item.posterImage,
                  item.free,
                  item,
                )}
                value={item.url}
              >
                <i className='fa fa-play-circle' />{' '}
                <div className='text-overflow'>{item.title}</div>
              </button>
            </div>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='col-sm-6 col-md-4'>
          <div className='card card-inverse card-primary'>
            <div className='card-header'>{language.LC().NO_RECORD_FOUND}</div>
            <div className='card-block' />
          </div>
        </div>
      );
    }
    return (
      <div className='coming_soon_wrap'>
        <div className='row'>
          <div className='col-xs-12 col-sm-6 col-md-6'>
            {this.state.type === 'intro' ? (
              <h4> Introduction </h4>
            ) : this.state.Chapter_Title ? (
              <h4> {this.state.Chapter_Title}</h4>
            ) : this.state.chapterName ? (
              <h4> {this.state.chapterName}</h4>
            ) : null}
          </div>
          <div className='col-xs-12 col-sm-6 col-md-6 text-right' style={styles_css}>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this.getChapters}
            >
              {language.LC().BACK_TO_VIDEOS}
            </button>
          </div>
        </div>
        <div>
          {this.state.chapters.length === 0 ? (
            <div className='loader_box'>
              <div className='sk-circle'>
                <div className='sk-circle1 sk-child' />
                <div className='sk-circle2 sk-child' />
                <div className='sk-circle3 sk-child' />
                <div className='sk-circle4 sk-child' />
                <div className='sk-circle5 sk-child' />
                <div className='sk-circle6 sk-child' />
                <div className='sk-circle7 sk-child' />
                <div className='sk-circle8 sk-child' />
                <div className='sk-circle9 sk-child' />
                <div className='sk-circle10 sk-child' />
                <div className='sk-circle11 sk-child' />
                <div className='sk-circle12 sk-child' />
              </div>
            </div>
          ) : (
            <div>
              <div className='video_outer'>
                <div className='row'>
                  <div className='col-xs-12 col-sm-8 col-md-8'>
                    <h5>{this.state.video_title}</h5>
                  </div>
                  <div className='col-xs-12 col-sm-4 col-md-4' style={styles_css}>
                    <div className='float-right text-right'>
                      {this.state.currentUrl === 0 || this.state.currentUrl < 0 ? null : (
                        <i
                          className='fa fa-angle-left ques_arrow pointer_class'
                          onClick={this.goToPreviousReading.bind(this)}
                        />
                      )}

                      {this.state.currentUrl === this.state.chapters.length - 1 ||
                      this.state.currentUrl >= this.state.chapters.length - 1 ? null : (
                        <i
                          className='fa fa-angle-right ques_arrow pointer_class'
                          onClick={this.goToNextReading.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className='row videos-main-wraper p-0'>
                  {/* <div className="videos-main-block"> */}
                  <div className='col-xs-12 col-sm-9 col-md-9 video-show-section'>
                    <div className='' id='video-height'>
                      {this.state.video_display_qq ? (
                        <div className='embed-responsive embed-responsive-16by9'>
                          <iframe
                            className='embed-responsive-item'
                            allowFullScreen
                            width='100%'
                            height='100%'
                            position='absolute'
                            top='10'
                            left='0'
                            src={flowPlayerVideoDisplayUrl(this.state.video_display_qq)}
                            sandbox='allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
                            title='0'
                            byline='0'
                            portrait='0'
                            frameborder='10'
                          />
                        </div>
                      ) : (
                        <div className='embed-responsive embed-responsive-16by9'>
                          <iframe
                            className='embed-responsive-item'
                            width={'100%'}
                            height={'100%'}
                            title={'video'}
                            frameBorder='0'
                            src={`https://www.youtube.com/embed/${
                              this.state.video_display
                            }?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 `}
                            allowFullScreen
                            sandbox='allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className='col-xs-12 col-sm-3 col-md-3 video-tag-heading'
                    id='video-tag-list'
                  >
                    <div className='link_list_wrap'>{data}</div>
                  </div>
                  {/* </div> */}
                </div>
              </div>
              <div> </div>
              <br /> <br />
              <VideoValidateReportIcons
                moveToNotes={this.moveToNotes}
                notesCSS={this.state.notesCSS}
                moveToPracticeQuestions={this.moveToPracticeQuestions}
                _saveFavVideo={this.saveFavVideo}
                _displayReportForm={this.displayReportForm}
                viewPdf={this.pdfOpen}
                pdfFile={pdf_file}
                bookmarkCSS={bookmarkCSS}
                bookmarkColor={bookmarkColor}
                type={type}
                questionsCSS={questionsCSS}
                saveVideo_text={saveVideo_text}
                currentReading={currentReading}
                chapters={chapters}
                showFreePremium={showFreePremium}
              />
              <br /> <br />
              <FlashCard
                item={{ id: currentReading }}
                type='video'
                isFlashCardHidden={isFlashCardHidden}
                ref={this.setChildRef}
                exam='frm'
                level={videoPartLevel}
              />
              <div className='row'>
                <div className='col-md-12'>
                  <div className={this.state.report_block}>
                    <div className='card-header'>
                      {language.LC().REPORT}
                      {/* <TooltipItem
                key="1"
                id="1"
                content={this.state.tooltips[1].placement}
                place_tip={this.state.tooltips[1].text_align}
              /> */}
                    </div>
                    {!this.state.successAlert ? (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong>{language.LC().COMMENT}</strong>
                            </label>
                          </div>
                          <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10'>
                            <textarea
                              id='comment'
                              name='comment'
                              rows='6'
                              className='form-control'
                              placeholder='Content..'
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class report-btn'
                              disabled={reportLoading}
                              onClick={this.reportQuestion.bind(this, this.state.currentReading)}
                            >
                              {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                            </button>
                            <button
                              type='button'
                              className='btn btn-danger active pointer_class margin_left_10'
                              onClick={this.hideReportForm.bind(this)}
                            >
                              {language.LC().CANCEL}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 report-Success-card'>
                            <img src={`${App_data.frontend_url}/img/success-ic.svg`} alt='' />
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                            </label>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class  min-vw-120'
                              onClick={this.onClose}
                            >
                              {' '}
                              {language.LC().CLOSE}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}{' '}
                  </div>
                </div>
              </div>
              <div className='row'>
              </div>
              <div>
                <ModalComponent
                  goPremium={this.goPremium.bind(this)}
                  toggleAlert={this.toggleAlert.bind(this)}
                  alert_status={this.state.alert_status}
                  MessageContent={this.state.MessageContent}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Frmvideodisplay;



// WEBPACK FOOTER //
// ./src/views/FRM/FRMVideoLessons/Frmvideodisplay/Frmvideodisplay.js